/* eslint-disable camelcase */
export class UserProfile {
  constructor ({ id_profile = -1, settings_id = -1, name = '', is_used = false, user_id = -1, updated_at = new Date().getTime(), nano_user = false } = {}) {
    this.idProfile = id_profile
    this.settingsId = settings_id
    this.name = name
    this.isUsed = is_used
    this.userId = user_id
    this.updatedAt = new Date(updated_at)
    this.nanoUser = nano_user
  }

  backendModel () {
    return {
      id_profile: this.idProfile,
      settings_id: this.settingsId,
      name: this.name,
      is_used: this.isUsed,
      updated_at: this.updatedAt.getTime()
    }
  }
}
